export const environment = {
    production: false,
    services: 'https://dafneqaservices.rextart.com/',
    geoserver_wfs_workspace_limiti_comunali:'DAFNE',
    geoserver_wfs_layer_limiti_comunali:'Com2016_ED50_g'
};